<template>
    <div>
        <aaa ref="loadmore" :allLoaded="true" :pullDown="true" @pullingDown="reload" class="box">
            <div class="aaaa">嗯</div>
        </aaa>
    </div>
</template>

<script>
import aaa from './scroll';

export default {
    components: {
        aaa
    },
    data() {
        return {
        };
    },
    mounted() {
        this.$refs.loadmore.finishPullUp();
        this.$refs.loadmore.finishPullDown();
    },
    methods: {
        reload() {
            setTimeout(() => {
                this.$refs.loadmore.finishPullUp();
                this.$refs.loadmore.finishPullDown();
            }, 100);
        }
    }
};
</script>
<style lang='stylus' scoped>
#app
    height 100%
    background #ccc
.box >>> .loadMoreContent
    background #4f578e
    background-size 7.5rem 10rem
    padding-top 9rem
    padding-bottom 2rem
.aaaa
    size 100% 500px
    background red
</style>
